<template>
  <aside
    :class="{ 'app-sidebar__open': showSidebar }"
    class="app-sidebar">
    <ul class="app-sidebar__menu">
      <!--
      <router-link
        v-if="loggedIn"
        :to="{ name: 'MyCourses' }"
        tag="li"
        @click.native="closeSidebar">
        My Courses
      </router-link>
      <router-link tag="li" :to="{ name: 'MediaLibrary' }"
        @click.native="closeSidebar">
        Media Library
      </router-link>
      <router-link tag="li" :to="{ name: 'LeaderBoard' }"
        @click.native="closeSidebar">
        Leaderboard
      </router-link>
      <router-link
        v-if="!loggedIn"
        :to="{ name: 'UserSignup' }"
        tag="li"
        @click.native="closeSidebar">
        Signup
      </router-link>
      <router-link
        v-if="!loggedIn"
        :to="{ name: 'UserLogin' }"
        tag="li"
        @click.native="closeSidebar">
        Login
      </router-link>
      <router-link
        v-if="loggedIn"
        :to="{ name: 'UserLogin' }"
        tag="li"
        @click.native="logout">
        Logout
      </router-link>
      -->
    </ul>
  </aside>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      showSidebar: state => state.showSidebar
    })
  },

  methods: {
    closeSidebar() {
      this.setSidebar(false)
    },

    logout() {
      this.closeSidebar()
      this.resetAuth()
    },

    ...mapActions({
      resetAuth: 'auth/reset',
      setSidebar: 'setSidebar'
    })
  }
}
</script>
